import { showSnackbarWithMessage } from './Snackbar/snackbar.saga';
import { call, select, put } from 'redux-saga/effects';
import { callService, CallApiOptions } from '../services/api';
import { stopAllLoaders } from './Config/config.actions';
import { resetAuth } from './Auth/auth.actions';
import { map, forEachObjIndexed, has } from 'ramda';
const DETAILED_ERRORKEYS = ['is_primary'];
const DETAILED_ERROR_DELIMITER = ', ';

export function getApiRoot() {
  if (window.location.hostname.indexOf('cms-staging.collins') > -1) {
    return 'https://cms-staging.collins.kg';
  }
  if (window.location.hostname.indexOf('cms.collins') > -1) {
    return 'https://cms.collins.kg';
  }
  return process.env.REACT_APP_API_ROOT;
}

export function* callApi(options: CallApiOptions) {
  const root = options.apiUrl ? options.apiUrl : getApiRoot();
  const state = yield select();

  const headers = new Headers();
  if (!options.noContentType) {
    headers.set('Content-Type', 'application/json');
  }
  if (state.auth && state.auth.isLoggedIn) {
    headers.set('Authorization', `Bearer ${state.auth.token}`);
  }

  const result = yield call(
    callService,
    {
      ...options,
      params: {
        ...options.params,
      },
      endpoint: `${root}/api/${options.endpoint}`,
    },
    headers
  );

  if (!result.ok) {
    const { statusCode, data } = result;

    if (statusCode === 401) {
      yield put(resetAuth());
      window.location.reload();
    } else if (data && data.code === 404) {
      console.warn(data.code, data.message);
    } else {
      const detailedError = getDetailedError(data && data.errors);
      yield showSnackbarWithMessage(
        'error',
        detailedError ||
          getMessageForStatusCode(data.code || statusCode, result)
      );
    }
    yield put(stopAllLoaders());
  }

  return result;
}

// todo rework. find proper error handling
export function getMessageForStatusCode(
  statusCode: number,
  result: any
): string {
  switch (statusCode) {
    case 503:
      if (has('lethe')) {
        throw 'Story could not be published. Error while pushing to Lethe!';
      }
      return 'Story could not be updated';
    case 413:
      return 'Filesize too large. Please check your uploaded file';
    case 422:
      return 'Api Error. Some required input fields are missing. Please provide all fields';
    default:
      return `API Error, Code: ${statusCode}`;
  }
}

export function getDetailedError(
  apiResults: { [key: string]: string | string[] }[]
): string | undefined {
  const errors: string[] = [];

  if (!apiResults) {
    return void 0;
  }

  map(item => {
    forEachObjIndexed((errorsForKey: string | string[], key) => {
      if (DETAILED_ERRORKEYS.indexOf(key.toString()) > -1) {
        const errorText: string = Array.isArray(errorsForKey)
          ? errorsForKey.join(DETAILED_ERROR_DELIMITER)
          : errorsForKey;
        errors.push(errorText);
      }
    }, item);
  }, apiResults);

  return errors.length > 0 ? errors.join(DETAILED_ERROR_DELIMITER) : void 0;
}



// WEBPACK FOOTER //
// ./src/store/api.ts